// Phase 1 hardcoded thresholds. Per spec section 3.
// Every gating metric maps to {pass, borderline} cutoffs.
// "pass" means the value is at or below the pass cutoff (or at/above for MOS).
// "borderline" means the value is at or below the borderline cutoff but above pass.
// Anything beyond borderline is fail.
export const THRESHOLDS = {
  downloadMbps:        { pass: 25,   borderline: 10,   direction: 'higher-is-better' },
  uploadMbps:          { pass: 10,   borderline: 5,    direction: 'higher-is-better' },
  capacityDownloadMbps:{ pass: 25,   borderline: 10,   direction: 'higher-is-better' },
  capacityUploadMbps:  { pass: 10,   borderline: 5,    direction: 'higher-is-better' },
  packetLossPct:        { pass: 0.5,  borderline: 1.5,  direction: 'lower-is-better' },
  jitterMs:             { pass: 15,   borderline: 30,   direction: 'lower-is-better' },
  rttMs:                { pass: 200,  borderline: 350,  direction: 'lower-is-better' },
  bufferbloatIncreaseMs:{ pass: 50,   borderline: 200,  direction: 'lower-is-better' },
  websocketP95Ms:       { pass: 300,  borderline: 500,  direction: 'lower-is-better' },
  websocketReconnects:  { pass: 0,    borderline: 1,    direction: 'lower-is-better' },
  mosScore:             { pass: 4.0,  borderline: 3.5,  direction: 'higher-is-better' }
};

export const MACHINE_THRESHOLDS = {
  cpuOpsPerSec:                 { pass: 8000000, borderline: 4000000, direction: 'higher-is-better' },
  deviceMemoryGb:               { pass: 8,       borderline: 4,       direction: 'higher-is-better' },
  cpuCores:                     { pass: 4,       borderline: 2,       direction: 'higher-is-better' },
  browserAgeMonths:             { pass: 12,      borderline: 24,      direction: 'lower-is-better' },
  hardwareAccelerationEnabled:  { direction: 'boolean-is-true' },
  webrtcSupported:              { direction: 'boolean-is-true' },
  webgl2Supported:              { direction: 'boolean-is-true' }
};

export const RESULT = Object.freeze({
  PASS: 'pass',
  BORDERLINE: 'borderline',
  FAIL: 'fail',
  NO_DATA: 'no_data',
  INCONCLUSIVE: 'inconclusive'
});
